import type { HomeWidgetSubject } from 'types/homeWidgetSharing';

/** The wording of each subject the gallery files a widget under. */
export const SUBJECT_LABEL: Record<HomeWidgetSubject, string> = {
    TIME: 'home.widgets.subject.time',
    BILLING: 'home.widgets.subject.billing',
    BUSINESS_DEVELOPMENT: 'home.widgets.subject.business-development',
    CASES: 'home.widgets.subject.cases',
    COMPLIANCE: 'home.widgets.subject.compliance',
};
